<template>
     <div class="k-page-content adver">
        <el-tabs v-model="activeName" class="box-eltab">
            <el-tab-pane label="广告组" name="adgroup">
                <div class="top-filter">
                    <el-form style="margin-bottom: 20px;" :inline="true" :size="size" class="demo-form-inline">
                        <el-form-item>
                            <el-input v-model="adgroupDataTable.name" clearable placeholder="请输入单元名称"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-date-picker
                                clearable
                                align="center"
                                :size="size"
                                v-model="adgroupDataTable.dateTime"
                                type="daterange"
                                value-format="yyyy-MM-dd"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                            ></el-date-picker>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="handleCurrentChangeAdgroup(1)">搜索</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div>
                    <div class="ks_toolbar" style="margin-bottom:10px;">
                        <p class="title">
                        <span>广告组记录</span>
                        <span style="margin-left:30px">
                            <el-link
                            style="font-size: 10px;"
                            type="primary"
                            :underline="false"
                            @click="changeMedia"
                            v-if="$parent.mediaOptions.length > 1"
                            >切换媒体</el-link>
                        </span>
                        </p>
                        <p>
                        <el-button type="primary" :size="size" @click="createTemplate">批量广告组</el-button>
                        </p>
                    </div>
                </div>
                <el-table
                v-loading="loading"
                border
                :data="adgroupDataTable.data"
                :header-cell-style="{background:'#f5f7fa'}"
                style="width: 100%"
              ></el-table>
            </el-tab-pane>
            <el-tab-pane label="创意" name="adcreative">
            </el-tab-pane>
        </el-tabs>
        <el-drawer
            title="批量广告组"
            :visible.sync="drawer"
            size="50%"
            direction="rtl"
            >
            <div class="rightDrawer">
                <div class="rightDrawerCenter">
                    <el-row type="flex" justify="center">
                        <el-col :span="24">
                            <el-form
                            ref="adgroupForm"
                            label-position="right"
                            :model="adgroupForm"
                            :rules="rules.adgroupForm"
                            :size="size"
                            label-width="130px"
                            v-loading="adgroupLoading"
                            >
                                <!-- 账户 -->
                                <el-card class="box-card" :shadow="hover">
                                    <div slot="header" class="clearfix">
                                        <span>账户</span>
                                    </div>
                                    <el-form-item label="投放账户" prop="advertiser_id" >
                                        <el-select
                                            clearable
                                            v-model="adgroupForm.advertiser_id"
                                            filterable
                                            remote
                                            reserve-keyword
                                            placeholder="请输入关键词"
                                            :remote-method="remoteAccount"
                                            @change="change_advertiser"
                                        >
                                            <el-option
                                            v-for="item in options.accounts"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value"
                                            ></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-card>
                                <!-- 营销内容 -->
                                <el-card
                                    class="box-card"
                                    :shadow="hover"
                                    v-if="adgroupForm.advertiser_id">
                                    <div slot="header" class="clearfix">
                                        <span>营销内容</span>
                                    </div>
                                    <div>
                                        <el-form-item
                                            label="营销目的"
                                            prop="marketing_goal">
                                            <el-radio-group v-model="adgroupForm.marketing_goal" @input="change_marketing_sub_goal_options">
                                                <el-radio-button v-for="item in options.marketing_goal_options" :key="item.value" :label="item.value" >{{ item.label }}</el-radio-button>
                                            </el-radio-group>
                                        </el-form-item>
                                        <el-form-item label="二级营销目的" prop="marketing_sub_goal">
                                            <el-select v-model="adgroupForm.marketing_sub_goal" placeholder="请选择二级营销目的" @change="change_marketing_target_type_options">
                                                <el-option
                                                v-for="item in options.marketing_sub_goal_options"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="推广产品类型" prop="marketing_asset_outer_spec.marketing_target_type">
                                            <el-select v-model="adgroupForm.marketing_asset_outer_spec.marketing_target_type" placeholder="请选择推广产品类型" @change="change_marketing_carrier_type_options">
                                                <el-option
                                                v-for="item in options.marketing_target_type_options"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <template v-if="['MARKETING_CARRIER_TYPE_APP_ANDROID','MARKETING_CARRIER_TYPE_APP_IOS','MARKETING_CARRIER_TYPE_WECHAT_MINI_GAME'].indexOf(adgroupForm.marketing_carrier_type) !== -1">
                                            <el-form-item label="营销载体ID" prop="marketing_carrier_detail.marketing_carrier_id">
                                                <el-input v-model="adgroupForm.marketing_carrier_detail.marketing_carrier_id" placeholder="请输入营销载体ID"></el-input>
                                            </el-form-item>
                                            <el-form-item label="二级营销载体ID">
                                                <el-input v-model="adgroupForm.marketing_carrier_detail.marketing_sub_carrier_id" placeholder="请输入二级营销载体ID"></el-input>
                                            </el-form-item>
                                            <el-form-item label="营销载体名称">
                                                <el-input v-model="adgroupForm.marketing_carrier_detail.marketing_carrier_name" placeholder="请输入营销载体名称"></el-input>
                                            </el-form-item>
                                        </template>
                                        <el-form-item label="选择产品" prop="marketing_asset_outer_spec.marketing_asset_outer_id" v-if="returnTypeStatus">
                                            <el-input readonly placeholder="请选择产品ID" v-model="adgroupForm.marketing_asset_outer_spec.marketing_asset_outer_id">
                                                <el-button slot="append" icon="el-icon-plus" @click="openProductDialog">选择产品</el-button>
                                            </el-input>
                                        </el-form-item>
                                        <el-form-item label="选择产品" prop="marketing_asset_id" v-if="!returnTypeStatus">
                                            <el-input readonly placeholder="请选择产品ID" v-model="adgroupForm.marketing_asset_id">
                                                <el-button slot="append" icon="el-icon-plus" @click="openProductDialog">选择产品</el-button>
                                            </el-input>
                                        </el-form-item>
                                        <el-form-item label="营销载体类型" prop="marketing_carrier_type">
                                            <el-select v-model="adgroupForm.marketing_carrier_type" placeholder="请选择营销载体类型">
                                                <el-option
                                                v-for="item in options.marketing_carrier_type_options"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="优化目标" prop="optimization_goal" v-if="['MARKETING_CARRIER_TYPE_APP_ANDROID','MARKETING_CARRIER_TYPE_APP_IOS','MARKETING_CARRIER_TYPE_WECHAT_MINI_GAME'].indexOf(adgroupForm.marketing_carrier_type) == -1">
                                            <el-select v-model="adgroupForm.optimization_goal" placeholder="请选择优化目标" @change="changeOptimizationGoal">
                                                <el-option
                                                v-for="item in options.optimization_goal_options"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="转化" v-else>
                                            <el-input readonly placeholder="请选择转化ID" v-model="adgroupForm.conversion_id">
                                                <el-button slot="append" icon="el-icon-plus" @click="openConversion">选择转化</el-button>
                                            </el-input>
                                        </el-form-item>
                                        <el-form-item label="深度优化ROI目标" prop="deep_conversion_spec.deep_conversion_worth_spec.goal" v-if="options.deep_conversion_worth_spec_options.length > 0">
                                            <el-select v-model="adgroupForm.deep_conversion_spec.deep_conversion_worth_spec.goal" placeholder="请选择深度优化ROI目标">
                                                <el-option
                                                v-for="item in options.deep_conversion_worth_spec_options"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="深度辅助优化ROI目标" prop="deep_conversion_spec.deep_conversion_worth_advanced_spec.goal" v-if="options.deep_conversion_worth_advanced_spec_options.length > 0">
                                            <el-select v-model="adgroupForm.deep_conversion_spec.deep_conversion_worth_advanced_spec.goal" placeholder="请选择深度优化ROI目标">
                                                <el-option
                                                v-for="item in options.deep_conversion_worth_advanced_spec_options"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="深度优化目标" prop="deep_conversion_spec.deep_conversion_behavior_spec.goal" v-if="options.deep_conversion_behavior_spec_options.length > 0">
                                            <el-select v-model="adgroupForm.deep_conversion_spec.deep_conversion_behavior_spec.goal" placeholder="请选择深度优化目标">
                                                <el-option
                                                v-for="item in options.deep_conversion_behavior_spec_options"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="深度辅助优化目标" prop="deep_conversion_spec.deep_conversion_behavior_advanced_spec.goal" v-if="options.deep_conversion_behavior_advanced_spec_options.length > 0">
                                            <el-select v-model="adgroupForm.deep_conversion_spec.deep_conversion_behavior_advanced_spec.goal" placeholder="请选择深度辅助优化目标">
                                                <el-option
                                                v-for="item in options.deep_conversion_behavior_advanced_spec_options"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="助攻行为目标" prop="forward_link_assist" v-if="options.forward_link_assist_options.length > 0">
                                            <el-select v-model="adgroupForm.forward_link_assist" placeholder="请选择助攻行为目标">
                                                <el-option
                                                v-for="item in options.forward_link_assist_options"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>                                        
                                    </div>
                                </el-card>
                                <!-- 版位 -->
                                <el-card
                                    class="box-card"
                                    v-if="adgroupForm.advertiser_id"
                                    :shadow="hover">
                                    <div slot="header" class="clearfix">
                                        <span>版位</span>
                                    </div>
                                    <div>
                                        <el-form-item label="版位类型" prop="automatic_site_enabled">
                                            <el-radio-group v-model="adgroupForm.automatic_site_enabled" @input="getSetList">
                                                <el-radio-button :label="true">自动版位</el-radio-button>
                                                <el-radio-button :label="false">特定版位</el-radio-button>
                                            </el-radio-group>
                                        </el-form-item>
                                        <el-form-item label="版位" v-if="!adgroupForm.automatic_site_enabled">
                                            <el-cascader-panel ref="setCascader" @change="changeSetSite" :props="{ multiple: true, emitPath:false}" :options="options.priority_site_set_options" v-model="adgroupForm.site_set"></el-cascader-panel>
                                        </el-form-item>
                                        <el-form-item label="探索策略" prop="exploration_strategy" v-if="adgroupForm.automatic_site_enabled">
                                            <el-radio-group v-model="adgroupForm.exploration_strategy" @input="getSetList"> 
                                                <el-radio-button label="AUTOMATIC_EXPLORATION">自动探索</el-radio-button>
                                                <el-radio-button label="STEADY_EXPLORATION">稳步探索</el-radio-button>
                                            </el-radio-group>
                                        </el-form-item>
                                        <el-form-item label="优先版位" v-if="adgroupForm.automatic_site_enabled && adgroupForm.exploration_strategy == 'STEADY_EXPLORATION'">
                                            <el-cascader-panel :props="{ multiple: true, emitPath:false}" :options="options.priority_site_set_options" v-model="adgroupForm.priority_site_set"></el-cascader-panel>
                                        </el-form-item>
                                        <el-form-item label="版位定投场景" v-if="adgroupForm.automatic_site_enabled || (!adgroupForm.automatic_site_enabled && (adgroupForm.site_set.indexOf('SITE_SET_CHANNELS')!=-1 || adgroupForm.site_set.indexOf('SITE_SET_WECHAT')!=-1 || adgroupForm.site_set.indexOf('SITE_SET_WECHAT_PLUGIN')!=-1 || adgroupForm.site_set.indexOf('SITE_SET_KANDIAN')!=-1 || adgroupForm.site_set.indexOf('SITE_SET_QQ_MUSIC_GAME')!=-1 || adgroupForm.site_set.indexOf('SITE_SET_TENCENT_NEWS')!=-1 || adgroupForm.site_set.indexOf('SITE_SET_TENCENT_VIDEO')!=-1))">
                                            <el-button icon="el-icon-plus" type="primary" @click="openSceneDialog">选择</el-button>
                                            <div v-for="(item, index) in this.scene_info" :key="index" style="margin-top:10px">
                                                <template v-if="item.content.length > 0">
                                                    <p>{{item.title}}:</p>
                                                    <p><el-tag :size="size" style="margin-right:5px" v-for="tag in item.content" :key="tag">{{ tag }}</el-tag></p>
                                                </template>
                                            </div>
                                        </el-form-item>
                                    </div>
                                </el-card>
                                <!-- 出价与预算 -->
                                <el-card
                                    class="box-card"
                                    :shadow="hover">
                                    <div slot="header" class="clearfix">
                                        <span>出价与预算</span>
                                    </div>
                                    <div>
                                        <el-form-item label="广告出价(元)" prop="bid_amount">
                                            <el-radio-group v-model="adgroupForm.automatic_site_enabled">
                                                <el-radio-button label="上海"></el-radio-button>
                                                <el-radio-button label="北京"></el-radio-button>
                                                <el-radio-button label="广州"></el-radio-button>
                                                <el-radio-button label="深圳"></el-radio-button>
                                            </el-radio-group>
                                        </el-form-item>
                                    </div>
                                </el-card>
                                <!-- 定向 -->
                                <el-card
                                    class="box-card"
                                    :shadow="hover">
                                    <div slot="header" class="clearfix">
                                        <span>定向</span>
                                    </div>
                                    <div>
                                        <el-form-item label="定向来源" prop="automatic_site_enabled">
                                            <el-radio-group v-model="target_type">
                                                <el-radio-button :label="true">模版导入</el-radio-button>
                                                <el-radio-button :label="false">自定义</el-radio-button>
                                            </el-radio-group>
                                        </el-form-item>
                                        <el-divider></el-divider>
                                        <el-form-item label="选择定向" v-if="target_type">
                                            <el-button icon="el-icon-plus" type="primary" @click="openTargetDialog">选择</el-button>
                                        </el-form-item>
                                        <el-tabs type="card" v-model="editableTabsValue" editable  @edit="handleTabsEdit" v-if="!target_type || (target_type && selectedRowTarget.length > 0)">
                                            <el-tab-pane :label="'定向包-'+(iindex+1)" :name="iitem.name" v-for="(iitem,iindex) in adgroupForm.targets" :key="iitem.name">
                                               
                                                <el-form-item label="地里位置">
                                                    <div>
                                                        <el-radio-group :size="size" v-model="iitem.type_arr.geo_location_type" @input="getTargetTagList">
                                                            <el-radio-button label="NONE">不限</el-radio-button>
                                                            <el-radio-button label="REGION">省市区县</el-radio-button>
                                                            <el-radio-button label="BUSINESS_DISTRICT">商圈</el-radio-button>
                                                        </el-radio-group>
                                                        <el-cascader-panel
                                                            v-if="iitem.type_arr.geo_location_type=='REGION'"
                                                            style="margin-top:10px"
                                                            v-model="iitem.geo_location.regions"
                                                            :options="options.regions_options"
                                                            :props="{multiple: true, emitPath:false}"
                                                            clearable>
                                                        </el-cascader-panel>
                                                        <el-cascader-panel
                                                            v-if="iitem.type_arr.geo_location_type=='BUSINESS_DISTRICT'"
                                                            style="margin-top:10px"
                                                            v-model="iitem.geo_location.business_districts"
                                                            :options="options.districts_options"
                                                            :props="{multiple: true, checkStrictly: true, emitPath:false}"
                                                            clearable>
                                                        </el-cascader-panel>
                                                    </div>
                                                    <div style="margin-top:10px" v-if="iitem.type_arr.geo_location_type!='NONE'">
                                                        <el-checkbox-group v-model="iitem.geo_location.location_types">
                                                            <el-checkbox label="RECENTLY_IN" :disabled="ttype=='BUSINESS_DISTRICT'">近期</el-checkbox>
                                                            <el-checkbox label="VISITED_IN">去过</el-checkbox>
                                                            <el-checkbox label="LIVE_IN">常住</el-checkbox>
                                                            <el-checkbox label="TRAVEL_IN" :disabled="ttype=='BUSINESS_DISTRICT'">旅行</el-checkbox>
                                                            <el-checkbox label="CAA_RECENTLY_IN" :disabled="ttype=='BUSINESS_DISTRICT'">CAA近期</el-checkbox>
                                                            <el-checkbox label="LIVE_AND_RECENTLY" :disabled="ttype=='BUSINESS_DISTRICT'">常驻且近期</el-checkbox>
                                                            <el-checkbox label="INTELLIGENCE" :disabled="ttype=='BUSINESS_DISTRICT'">预估实时位置</el-checkbox>
                                                        </el-checkbox-group>
                                                    </div>
                                                </el-form-item>
                                                <el-form-item label="性别">
                                                    <el-checkbox-group v-model="iitem.gender" @change="noneAction($event,iindex,['gender'],1)">
                                                        <el-checkbox label="NONE">不限</el-checkbox>
                                                        <el-checkbox label="MALE">男性</el-checkbox>
                                                        <el-checkbox label="FEMALE">女性</el-checkbox>
                                                    </el-checkbox-group>
                                                </el-form-item>
                                                <el-form-item label="年龄">
                                                    <el-radio-group v-model="iitem.type_arr.age_type">
                                                        <el-radio-button label="NONE">不限</el-radio-button>
                                                        <el-radio-button label="CUSTOM">自定义</el-radio-button>
                                                    </el-radio-group>
                                                    <el-row v-for="(item,index) in iitem.age" :key="index" style="margin-bottom: 8px;margin-top:10px" v-if="iitem.type_arr.age_type=='CUSTOM'">
                                                        <el-input-number v-model="item.min" controls-position="right" :min="14" :max="66"></el-input-number>
                                                        -
                                                        <el-input-number v-model="item.max" controls-position="right" :min="14" :max="66"></el-input-number>
                                                        <el-button type="primary" icon="el-icon-plus" style="margin-left: 5px" v-if="index==0" @click="addAgeInfo(iindex)"></el-button>
                                                        <el-button type="danger" icon="el-icon-close" style="margin-left: 5px" v-else @click="delAgeInfo(iindex)"></el-button>
                                                    </el-row>
                                                </el-form-item>
                                                <el-form-item label="学历">
                                                    <el-checkbox-group v-model="iitem.education" @change="noneAction($event,iindex,['education'])">
                                                        <el-checkbox label="NONE">不限</el-checkbox>
                                                        <el-checkbox label="DOCTOR">博士</el-checkbox>
                                                        <el-checkbox label="MASTER">硕士</el-checkbox>
                                                        <el-checkbox label="BACHELOR">本科</el-checkbox>
                                                        <el-checkbox label="SENIOR">高中</el-checkbox>
                                                        <el-checkbox label="JUNIOR">初中</el-checkbox>
                                                        <el-checkbox label="PRIMARY">小学</el-checkbox>
                                                        <el-checkbox label="JUNIOR_COLLEGE">专科</el-checkbox>
                                                    </el-checkbox-group>
                                                </el-form-item>
                                                <el-form-item label="应用安装">
                                                    <el-checkbox-group v-model="iitem.app_install_status" @change="noneAction($event,iindex,['app_install_status'],1)">
                                                        <el-checkbox  label="NONE">不限</el-checkbox>
                                                        <el-checkbox  label="NOT_INSTALLED">未安装</el-checkbox>
                                                        <el-checkbox  label="INSTALLED">已安装</el-checkbox>
                                                    </el-checkbox-group>
                                                </el-form-item>
                                                <el-form-item label="婚恋状态">
                                                    <el-checkbox-group v-model="iitem.marital_status" @change="noneAction($event,iindex,['marital_status'])">
                                                        <el-checkbox label="NONE">不限</el-checkbox>
                                                        <el-checkbox label="SINGLE">单身</el-checkbox>
                                                        <el-checkbox label="IN_LOVE">热恋</el-checkbox>
                                                        <el-checkbox label="NEWLY_MARRIED">新婚</el-checkbox>
                                                        <el-checkbox label="MARRIED">已婚</el-checkbox>
                                                        <el-checkbox label="PARENTING">育儿</el-checkbox>
                                                        <el-checkbox label="PARENTING_0">育儿(孕育中)</el-checkbox>
                                                        <el-checkbox label="PARENTING_0_6">育儿(宝宝0-6个月)</el-checkbox>
                                                        <el-checkbox label="PARENTING_6_12">育儿(宝宝6-12个月)</el-checkbox>
                                                        <el-checkbox label="PARENTING_12_24">育儿(宝宝1-2岁)</el-checkbox>
                                                        <el-checkbox label="PARENTING_24_36">育儿(宝宝2-3岁)</el-checkbox>
                                                        <el-checkbox label="CHILD_PRE_SCHOOL">育儿(宝宝3-6周岁)</el-checkbox>
                                                        <el-checkbox label="CHILD_PRIMARY_SCHOOL">育儿(宝宝6-12周岁)</el-checkbox>
                                                        <el-checkbox label="CHILD_JUNIOR_SCHOOL">育儿(宝宝12-15周岁)</el-checkbox>
                                                        <el-checkbox label="CHILD_HIGH_SCHOOL">育儿(宝宝15-18周岁)</el-checkbox>
                                                    </el-checkbox-group>
                                                </el-form-item>
                                                <el-form-item label="联网方式">
                                                    <el-checkbox-group v-model="iitem.network_type" @change="noneAction($event,iindex,['network_type'])">
                                                        <el-checkbox label="NONE">不限</el-checkbox>
                                                        <el-checkbox label="WIFI">无线网络</el-checkbox>
                                                        <el-checkbox label="NET_2G">2G 网络</el-checkbox>
                                                        <el-checkbox label="NET_3G">3G 网络</el-checkbox>
                                                        <el-checkbox label="NET_4G">4G 网络</el-checkbox>
                                                        <el-checkbox label="NET_5G">5G 网络</el-checkbox>
                                                    </el-checkbox-group>
                                                </el-form-item>
                                                <el-form-item label="设备价格">
                                                    <el-checkbox-group v-model="iitem.device_price" @change="noneAction($event,iindex,['device_price'])">
                                                        <el-checkbox label="NONE">不限</el-checkbox>
                                                        <el-checkbox label="PRICE_1500_LESS">￥1500以下</el-checkbox>
                                                        <el-checkbox label="PRICE_1500_2500">￥1500~2500</el-checkbox>
                                                        <el-checkbox label="PRICE_2500_3500">￥2500~3500</el-checkbox>
                                                        <el-checkbox label="PRICE_3500_4500">￥3500~4500</el-checkbox>
                                                        <el-checkbox label="PRICE_4500_MORE">￥4500以上</el-checkbox>
                                                    </el-checkbox-group>
                                                </el-form-item>
                                                <el-form-item label="消费能力">
                                                    <el-checkbox-group v-model="iitem.game_consumption_level" @change="noneAction($event,iindex,['game_consumption_level'])">
                                                        <el-checkbox label="NONE">不限</el-checkbox>
                                                        <el-checkbox  label="HIGH">高消费用户</el-checkbox>
                                                        <el-checkbox  label="NORMAL">普通消费用户</el-checkbox>
                                                    </el-checkbox-group>
                                                </el-form-item>
                                                <el-form-item label="操作系统">
                                                    <el-checkbox-group :size="size" v-model="iitem.type_arr.os_type" @change="typeAction($event,iindex,['os_type'])">
                                                        <el-checkbox-button label="NONE">不限</el-checkbox-button>
                                                        <el-checkbox-button label="USER_OS">定向操作系统</el-checkbox-button>
                                                        <el-checkbox-button label="EXCLUED_OS">排除操作系统</el-checkbox-button>
                                                    </el-checkbox-group>
                                                    <div style="margin-top:20px" v-if="iitem.type_arr.os_type.indexOf('USER_OS') != -1">
                                                        <p><i class="el-icon-s-operation" style="margin-right:10px"></i>定向操作系统:</p>
                                                        <el-cascader-panel @change="osChange($event,iindex,'exclude_os_options')" :props="{ multiple: true, emitPath:false}" :options="iitem.options.os_options" v-model="iitem.user_os"></el-cascader-panel>
                                                    </div>
                                                    <div style="margin-top:20px" v-if="iitem.type_arr.os_type.indexOf('EXCLUED_OS') != -1">
                                                        <p><i class="el-icon-s-operation" style="margin-right:10px"></i>排除操作系统:</p>
                                                        <el-cascader-panel @change="osChange($event,iindex,'os_options')" :props="{ multiple: true, emitPath:false}" :options="iitem.options.exclude_os_options" v-model="iitem.excluded_os"></el-cascader-panel>
                                                    </div>
                                                </el-form-item>
                                                <el-form-item label="排除已转化人群行为" v-if="iitem.excluded_converted_audience">
                                                    <el-select style="margin-left:5px;" v-model="iitem.excluded_converted_audience.excluded_dimension" placeholder="请选择数据维度">
                                                        <el-option label="广告主" value="EXCLUDED_DIMENSION_UID"></el-option>
                                                        <el-option label="公司主体" value="EXCLUDED_DIMENSION_COMPANY_ACCOUNT"></el-option>
                                                        <el-option label="应用" value="EXCLUDED_DIMENSION_APP"></el-option>
                                                        <el-option label="商品" value="EXCLUDED_DIMENSION_PRODUCT"></el-option>
                                                    </el-select>
                                                    <el-select style="margin-left:5px;" v-model="iitem.excluded_converted_audience.conversion_behavior_list" multiple :multiple-limit=2 placeholder="请选择转化行为">
                                                        <el-option
                                                            v-for="item in options.optimization_goal_options"
                                                            :key="item.value"
                                                            :label="item.label"
                                                            :value="item.value">
                                                        </el-option>
                                                    </el-select>
                                                    <el-select style="margin-left:5px;" v-model="iitem.excluded_converted_audience.excluded_day" placeholder="请选择排除天数">
                                                        <el-option label="7天" value="EXCLUDED_DAY_SEVEN_DAY"></el-option>
                                                        <el-option label="一个月" value="EXCLUDED_DAY_ONE_MONTH"></el-option>
                                                        <el-option label="一天" value="EXCLUDED_DAY_ONE_DAY"></el-option>
                                                    </el-select>
                                                </el-form-item>
                                                <el-form-item label="人群定向">
                                                    <el-checkbox-group :size="size" v-model="iitem.type_arr.audience_type" @change="typeAction($event,iindex,['audience_type'])">
                                                        <el-checkbox-button label="NONE">不限</el-checkbox-button>
                                                        <el-checkbox-button label="ACTIONS">定向人群</el-checkbox-button>
                                                        <el-checkbox-button label="EXCLUED_ACTIONS">排除人群</el-checkbox-button>
                                                    </el-checkbox-group>
                                                    <div style="margin-top:20px" v-if="iitem.type_arr.audience_type.indexOf('ACTIONS') != -1">
                                                        <el-select filterable v-model="iitem.custom_audience" style="width:250px" multiple placeholder="请选择定向人群" @change="exChange($event,iindex,'excluded_audience_options')">
                                                            <el-option v-for="it in iitem.options.include_audience_options" :key="it.value" :label="it.label" :value="it.value" :disabled="it.disabled"></el-option>
                                                        </el-select>
                                                    </div>
                                                    <div style="margin-top:20px" v-if="iitem.type_arr.audience_type.indexOf('EXCLUED_ACTIONS') != -1">
                                                        <el-select filterable v-model="iitem.excluded_custom_audience" style="width:250px" multiple placeholder="请选择排除人群" @change="exChange($event,iindex,'include_audience_options')">
                                                            <el-option v-for="it in iitem.options.excluded_audience_options" :key="it.value" :label="it.label" :value="it.value" :disabled="it.disabled"></el-option>
                                                        </el-select>
                                                    </div>
                                                </el-form-item>
                                                <el-form-item label="设备品牌型号定向">
                                                    <el-checkbox-group :size="size" v-model="iitem.type_arr.wechat_type" @change="typeAction($event,iindex,['wechat_type'])">
                                                        <el-checkbox-button label="NONE">不限</el-checkbox-button>
                                                        <el-checkbox-button label="ACTIONS">定向设备品牌</el-checkbox-button>
                                                        <el-checkbox-button label="EXCLUED_ACTIONS">排除设备品牌</el-checkbox-button>
                                                    </el-checkbox-group>
                                                    <div style="margin-top:20px" v-if="iitem.type_arr.wechat_type.indexOf('ACTIONS') != -1">
                                                        <p><i class="el-icon-s-operation" style="margin-right:10px"></i>定向设备品牌型号:</p>
                                                        <el-cascader-panel @change="osChange($event,iindex,'excluded_list_options')" :props="{ multiple: true, emitPath:false}" :options="iitem.options.included_list_options" v-model="iitem.user_os"></el-cascader-panel>
                                                    </div>
                                                    <div style="margin-top:20px" v-if="iitem.type_arr.wechat_type.indexOf('EXCLUED_ACTIONS') != -1">
                                                        <p><i class="el-icon-s-operation" style="margin-right:10px"></i>排除设备品牌型号:</p>
                                                        <el-cascader-panel @change="osChange($event,iindex,'included_list_options')" :props="{ multiple: true, emitPath:false}" :options="iitem.options.excluded_list_options" v-model="iitem.excluded_os"></el-cascader-panel>
                                                    </div>
                                                </el-form-item>
                                                <el-form-item label="微信再营销类型">
                                                    <el-checkbox-group :size="size" v-model="iitem.type_arr.wechat_ad_type" @change="typeAction($event,iindex,['wechat_ad_type'])">
                                                        <el-checkbox-button label="NONE">不限</el-checkbox-button>
                                                        <el-checkbox-button label="ACTIONS">定向营销类型</el-checkbox-button>
                                                        <el-checkbox-button label="EXCLUED_ACTIONS">排除营销类型</el-checkbox-button>
                                                    </el-checkbox-group>
                                                    <div style="margin-top:20px" v-if="iitem.type_arr.wechat_ad_type.indexOf('ACTIONS') != -1">
                                                        <el-select v-model="iitem.wechat_ad_behavior.actions" style="width:250px" multiple placeholder="请选择微信再营销类型" @change="exChange($event,iindex,'excluded_ad_options')">
                                                            <el-option v-for="it in iitem.options.include_ad_options" :key="it.value" :label="it.label" :value="it.value" :disabled="it.disabled"></el-option>
                                                        </el-select>
                                                    </div>
                                                    <div style="margin-top:20px" v-if="iitem.type_arr.wechat_ad_type.indexOf('EXCLUED_ACTIONS') != -1">
                                                        <el-select v-model="iitem.wechat_ad_behavior.excluded_actions" style="width:250px" multiple placeholder="请选择排除微信再营销类型" @change="exChange($event,iindex,'include_ad_options')">
                                                            <el-option v-for="it in iitem.options.excluded_ad_options" :key="it.value" :label="it.label" :value="it.value" :disabled="it.disabled"></el-option>
                                                        </el-select>
                                                    </div>
                                                </el-form-item>
                                            </el-tab-pane>
                                        </el-tabs> 
                                    </div>
                                </el-card>
                                <!-- 广告组 -->
                                <el-card
                                    class="box-card"
                                    :shadow="hover">
                                    <div slot="header" class="clearfix">
                                        <span>广告设置</span>
                                    </div>
                                    <div>
                                        <el-form-item label="广告组名称" prop="adgroup_name">
                                            <el-input v-model="adgroupForm.adgroup_name" placeholder="请输入广告组名称"></el-input>
                                        </el-form-item>
                                        <el-form-item required label="开始投放日期" prop="end_date">
                                            <div class="date-pickers">
                                                <el-date-picker
                                                :picker-options="pickerOptions"
                                                placement="bottom-start"
                                                v-model="adgroupForm.begin_date"
                                                type="date"
                                                value-format="yyyy-MM-dd"
                                                placeholder="开始投放日期">
                                                </el-date-picker>
                                                <el-date-picker
                                                :picker-options="pickerOptions"
                                                placement="bottom-start"
                                                v-model="adgroupForm.end_date"
                                                type="date"
                                                value-format="yyyy-MM-dd"
                                                placeholder="结束投放日期">
                                                </el-date-picker>
                                            </div>
                                        </el-form-item>
                                        <el-form-item label="首日投放时间">
                                            <el-time-picker
                                                placement="bottom-start"
                                                v-model="adgroupForm.first_day_begin_time"
                                                placeholder="投放时间">
                                            </el-time-picker>
                                        </el-form-item>
                                        <el-form-item label="时段" prop="time_series">
                                            <el-input v-model="adgroupForm.time_series" readonly style="width:300px">
                                                <el-button
                                                slot="append"
                                                icon="el-icon-thumb"
                                                @click="scheduleTimeVisible = true"
                                                >选择时段</el-button>
                                            </el-input>
                                            <Time
                                                :visible.sync="scheduleTimeVisible"
                                                :time.sync="adgroupForm.time_series"
                                            ></Time>
                                        </el-form-item>
                                        <el-form-item label="监测组链接" prop="feedback_id">
                                            <el-select v-model="adgroupForm.feedback_id" placeholder="请选择监测组链接">
                                                <el-option
                                                v-for="item in options.feedback_id_options"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </div>
                                </el-card>
                            </el-form>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </el-drawer>
        <el-dialog title="选择产品" :visible.sync="dialogTableVisible" width="40%">
            <el-form :size="size" ref="productForm" :model="productForm" :inline="true" :rules="rules.productForm">
                <el-form-item>
                    <el-input v-model="productForm.id" placeholder="输入产品ID" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="productForm.name" placeholder="输入产品名称" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="onSubmit">搜索</el-button>
                </el-form-item>
            </el-form>
            <el-table :data="options.marketing_target_assets_options.data" border stripe @row-click="handleRowClick" height="200">
                <el-table-column width="40">
                    <template slot-scope="scope">
                        <i v-if="scope.row === selectedRow" class="el-icon-check" style="color: green;font-size: 18px;font-weight: bold;"></i>
                    </template>
                </el-table-column>
                <el-table-column property="value" label="产品ID"></el-table-column>
                <el-table-column property="label" label="产品名称"></el-table-column>
                <el-table-column label="详情">
                    <template slot-scope="scope">
                        <el-popover
                        placement="right"
                        width="300"
                        trigger="click">
                        <p v-for="(item,key) in scope.row.other" :key="key"> <span>{{key}}</span> : <span>{{ item }}</span></p>
                        <el-button slot="reference" type="text">详情</el-button>
                        </el-popover>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
            small
            @current-change="get_marketing_target_assets"
            layout="total,prev, pager, next"
            :page-size="options.marketing_target_assets_options.pagesize | number"
            :total="options.marketing_target_assets_options.total | number">
            </el-pagination>
            <div slot="footer" class="dialog-footer">
                <el-button :size="size" @click="dialogTableVisible = false">取 消</el-button>
                <el-button :size="size" type="primary" @click="actionId">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="选择转化" :visible.sync="dialogConversionVisible" width="40%">
            <el-form :size="size" ref="conversionForm" :model="conversionForm" :inline="true">
                <el-form-item>
                    <el-input v-model="conversionForm.id" placeholder="输入转化ID" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="onSubmitConversion">搜索</el-button>
                </el-form-item>
            </el-form>
            <el-table :data="options.conversion_id_options.data" border stripe @row-click="handleRowClickConversion" height="200">
                <el-table-column width="40">
                    <template slot-scope="scope">
                        <i v-if="scope.row === selectedRowConver" class="el-icon-check" style="color: green;font-size: 18px;font-weight: bold;"></i>
                    </template>
                </el-table-column>
                <el-table-column property="conversion_id" label="转化ID" min-width="80px"></el-table-column>
                <el-table-column property="conversion_name" label="转化名称" min-width="220px"></el-table-column>
                <el-table-column property="access_type" label="上报方式"></el-table-column>
                <el-table-column property="optimization_goal" label="优化类型"></el-table-column>
                <el-table-column property="deep_behavior_optimization_goal" label="深度优化"></el-table-column>
            </el-table>
            <el-pagination
            small
            @current-change="get_conversion_id_options"
            layout="total, prev, pager, next"
            :page-size="options.conversion_id_options.pagesize | number"
            :total="options.conversion_id_options.total | number">
            </el-pagination>
            <div slot="footer" class="dialog-footer">
                <el-button :size="size" @click="dialogConversionVisible = false">取 消</el-button>
                <el-button :size="size" type="primary" @click="actionConverId">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="选择场景" :visible.sync="dialogSceneVisible" width="40%" :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
            <el-collapse v-model="activeNames">
                <el-collapse-item title="微信公众号与小程序定投" name="1" v-if="adgroupForm.automatic_site_enabled || (!adgroupForm.automatic_site_enabled && (adgroupForm.site_set.indexOf('SITE_SET_WECHAT_PLUGIN')!= -1 || adgroupForm.site_set.indexOf('SITE_SET_WECHAT')!= -1))">
                    <div>
                        <el-radio-group :size="size" v-model="isOpen.wx_xcx_dt" @input="($event)=>changeScene($event, 'WECHAT_POSITION')">
                            <el-radio-button :label="false">不限</el-radio-button>
                            <el-radio-button :label="true">自定义</el-radio-button>
                        </el-radio-group>
                    </div>
                    <div v-if="isOpen.wx_xcx_dt" style="margin-top:15px;margin-left:25px;">
                        <el-checkbox-group :size="size" v-model="adgroupForm.scene_spec.wechat_position">
                            <el-checkbox v-for="item in options.wechat_position_options" :key="item.value" :label="item.value">{{ item.label }}</el-checkbox>
                        </el-checkbox-group>
                    </div>
                </el-collapse-item>
                <el-collapse-item title="微信视频号定投" name="2" v-if="adgroupForm.automatic_site_enabled || (!adgroupForm.automatic_site_enabled && adgroupForm.site_set.indexOf('SITE_SET_CHANNELS')!= -1)">
                    <div>
                        <el-radio-group :size="size" v-model="isOpen.wx_sph_dt" @input="($event)=>changeScene($event, 'WECHAT_CHANNELS_SCENE')">
                            <el-radio-button :label="false">不限</el-radio-button>
                            <el-radio-button :label="true">自定义</el-radio-button>
                        </el-radio-group>
                    </div>
                    <div v-if="isOpen.wx_sph_dt" style="margin-top:15px;margin-left:25px;">
                        <el-checkbox-group :size="size" v-model="adgroupForm.scene_spec.wechat_channels_scene">
                            <el-checkbox v-for="item in options.wechat_channels_scene_options" :key="item.value" :label="item.value">{{ item.label }}</el-checkbox>
                        </el-checkbox-group>
                    </div>
                </el-collapse-item>
                <el-collapse-item title="微信公众号与小程序场景" name="3" v-if="adgroupForm.automatic_site_enabled || (!adgroupForm.automatic_site_enabled && (adgroupForm.site_set.indexOf('SITE_SET_WECHAT_PLUGIN')!= -1 || adgroupForm.site_set.indexOf('SITE_SET_WECHAT')!= -1))">
                    <div>
                        <el-radio-group :size="size" v-model="isOpen.wx_xcx_cj" @input="($event)=>changeScene($event, 'OFFICIAL_ACCOUNT_MEDIA_CATEGORY-MINI_PROGRAM_AND_MINI_GAME-PAY_SCENE')">
                            <el-radio-button :label="false">不限</el-radio-button>
                            <el-radio-button :label="true">自定义</el-radio-button>
                        </el-radio-group>
                    </div>
                    <div v-if="isOpen.wx_xcx_cj" style="margin-top:15px;margin-left:25px;">
                        <p style="font-weight:bold;">公众号媒体类型 <el-tooltip content="场景对应定投广告位：公众号文章底部、公众号文章中部、公众号文章视频贴片" placement="right" effect="light"><i class="el-icon-info" style="color: #909399;"></i></el-tooltip></p>
                        <el-checkbox-group :size="size" v-model="adgroupForm.scene_spec.wechat_scene.official_account_media_category">
                            <el-checkbox v-for="item in options.official_account_media_category_options" :key="item.value" :label="item.value">{{ item.label }}</el-checkbox>
                        </el-checkbox-group>
                    </div>
                    <div v-if="isOpen.wx_xcx_cj" style="margin-top:15px;margin-left:25px;">
                        <p style="font-weight:bold;">小程序小游戏流量类型 <el-tooltip content="场景对应定投广告位：小程序banner广告、小程序激励式广告、小程序插屏广告、小程序封面广告" placement="right" effect="light"><i class="el-icon-info" style="color: #909399;"></i></el-tooltip></p>
                        <el-checkbox-group :size="size" v-model="adgroupForm.scene_spec.wechat_scene.mini_program_and_mini_game">
                            <el-checkbox v-for="item in options.mini_program_and_mini_game_options" :key="item.value" :label="item.value">{{ item.label }}</el-checkbox>
                        </el-checkbox-group>
                    </div>
                    <div v-if="isOpen.wx_xcx_cj" style="margin-top:15px;margin-left:25px;">
                        <p style="font-weight:bold;">订单详情页消费场景 <el-tooltip content="场景对应定投广告位：微信支付订单详情页" placement="right" effect="light"><i class="el-icon-info" style="color: #909399;"></i></el-tooltip></p>
                        <el-checkbox-group :size="size" v-model="adgroupForm.scene_spec.wechat_scene.pay_scene">
                            <el-checkbox v-for="item in options.pay_scene_options" :key="item.value" :label="item.value">{{ item.label }}</el-checkbox>
                        </el-checkbox-group>
                    </div>
                </el-collapse-item>
                <el-collapse-item title="优量汇广告展示场景" name="4" v-if="adgroupForm.automatic_site_enabled || (!adgroupForm.automatic_site_enabled && adgroupForm.site_set.indexOf('SITE_SET_MOBILE_UNION')!= -1)">
                    <div>
                        <el-radio-group :size="size" v-model="isOpen.ylh_gg_cj" @input="($event)=>changeScene($event, 'zz')">
                            <el-radio-button :label="false">不限</el-radio-button>
                            <el-radio-button :label="true">自定义</el-radio-button>
                        </el-radio-group>
                    </div>
                    <div v-if="isOpen.ylh_gg_cj" style="margin-top:15px;margin-left:25px;">
                        <el-checkbox-group v-model="adgroupForm.scene_spec.display_scene">
                            <el-checkbox v-for="item in options.display_scene_options" :key="item.value" :label="item.value">{{ item.label }}</el-checkbox>
                        </el-checkbox-group>
                    </div>
                </el-collapse-item>
                <el-collapse-item title="优量汇媒体类型" name="5" v-if="adgroupForm.automatic_site_enabled || (!adgroupForm.automatic_site_enabled && adgroupForm.site_set.indexOf('SITE_SET_MOBILE_UNION')!= -1)">
                    <div>
                        <el-radio-group :size="size" v-model="isOpen.ylh_mt_lx" @input="($event)=>changeScene($event, 'MOBILE_UNION_CATEGORY')">
                            <el-radio-button :label="false">不限</el-radio-button>
                            <el-radio-button :label="true">自定义</el-radio-button>
                        </el-radio-group>
                    </div>
                    <div v-if="isOpen.ylh_mt_lx" style="margin-top:15px;margin-left:25px;">
                        <el-cascader-panel :props="{ multiple: true, emitPath:false}" :options="options.mobile_union_category_options" v-model="adgroupForm.scene_spec.mobile_union_category"></el-cascader-panel>
                    </div>
                </el-collapse-item>
                <el-collapse-item title="优量汇自定义定投" name="6" v-if="adgroupForm.automatic_site_enabled || (!adgroupForm.automatic_site_enabled && adgroupForm.site_set.indexOf('SITE_SET_MOBILE_UNION')!= -1)">
                    <div>
                        <el-radio-group :size="size" v-model="isOpen.ylh_zdy_dt" @input="($event)=>changeScene($event, 'UNION_PACKAGE_TYPE_INCLUDE')">
                            <el-radio-button :label="false">不限</el-radio-button>
                            <el-radio-button :label="true">自定义</el-radio-button>
                        </el-radio-group>
                    </div>
                    <div v-if="isOpen.ylh_zdy_dt" style="margin-top:15px;margin-left:25px;">
                        <el-checkbox-group :size="size" v-model="adgroupForm.scene_spec.union_position_package">
                            <el-checkbox v-for="item in options.union_position_package_options" :key="item.value" :label="item.value">{{ item.label }}</el-checkbox>
                        </el-checkbox-group>
                    </div>
                </el-collapse-item>
                <el-collapse-item title="优量汇自定义屏蔽" name="7" v-if="adgroupForm.automatic_site_enabled || (!adgroupForm.automatic_site_enabled && adgroupForm.site_set.indexOf('SITE_SET_MOBILE_UNION')!= -1)">
                    <div>
                        <el-radio-group :size="size" v-model="isOpen.ylh_zdy_pb" @input="($event)=>changeScene($event, 'UNION_PACKAGE_TYPE_EXCLUDE')">
                            <el-radio-button :label="false">不限</el-radio-button>
                            <el-radio-button :label="true">自定义</el-radio-button>
                        </el-radio-group>
                    </div>
                    <div v-if="isOpen.ylh_zdy_pb" style="margin-top:15px;margin-left:25px;">
                        <el-checkbox-group :size="size" v-model="adgroupForm.scene_spec.exclude_union_position_package">
                            <el-checkbox v-for="item in options.exclude_union_position_package_options" :key="item.value" :label="item.value">{{ item.label }}</el-checkbox>
                        </el-checkbox-group>
                    </div>
                </el-collapse-item>
            </el-collapse>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" :size="size" @click="closeDialogToView">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="选择定向" :visible.sync="dialogTargetVisible" width="40%">
            <el-form :size="size" ref="targetForm" :model="targetForm" :inline="true">
                <el-form-item>
                    <el-input v-model="conversionForm.id" placeholder="输入定向名称" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="onSubmitTarget">搜索</el-button>
                </el-form-item>
            </el-form>
            <el-table :data="options.targeting_options.data" border stripe @selection-change="handleRowClickTarget" height="200">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column property="targeting_id" label="定向ID" min-width="100px"></el-table-column>
                <el-table-column property="targeting_name" label="定向名称" min-width="200px"></el-table-column>
                <el-table-column property="targeting_source_msg" label="来源" min-width="80px"></el-table-column>
                <el-table-column property="targeting_translation" label="位置" min-width="80px">
                    <template slot-scope="scope">
                        <el-popover
                            placement="bottom"
                            title="标题"
                            width="200"
                            trigger="click"
                            :content="scope.row.targeting_translation">
                            <el-button slot="reference" type="text">详情</el-button>
                        </el-popover>
                        
                    </template>
                </el-table-column>
                <el-table-column property="is_deleted" label="状态" min-width="80px">
                    <template slot-scope="scope">
                        {{scope.row.is_deleted?'已删除':'正常'}}
                    </template>
                </el-table-column>
                <el-table-column property="created_time" label="创建日期"></el-table-column>
            </el-table>
            <el-pagination
            small
            @current-change="getTargetingList"
            layout="total, prev, pager, next"
            :page-size="options.targeting_options.pagesize | number"
            :total="options.targeting_options.total | number">
            </el-pagination>
            <div slot="footer" class="dialog-footer">
                <el-button :size="size" @click="dialogTargetVisible = false">取 消</el-button>
                <el-button :size="size" type="primary" @click="actionTargetId">确 定</el-button>
            </div>
        </el-dialog>
     </div>
</template>
<script>
import Time from '@/components/Time.vue'
export default {
    components: {
        Time
    },
    data() {
        return {
            loading:false,
            editableTabsValue:'1',
            selectedRow: null,
            selectedRowConver: null,
            selectedRowTarget: [],
            dialogSceneVisible:false,
            dialogTargetVisible:false,
            dialogConversionVisible:false,
            dialogTableVisible:false,
            scheduleTimeVisible:false,
            activeName:'adgroup',
            size:'mini',
            hover: 'hover',
            target_type:true,
            adgroupDataTable:{},
            drawer:false,
            adgroupLoading:false,
            scene_info:[],
            productForm:{
                name:'',
                id:''
            },
            conversionForm:{id:''},
            targetForm:{name:''},
            activeNames: ['1','2','3','4','5','6','7'],
            isOpen:{
                wx_xcx_dt:false,
                wx_sph_dt:false,
                wx_xcx_cj:false,
                ylh_gg_cj:false,
                ylh_mt_lx:false,
                ylh_zdy_dt:false,
                ylh_zdy_pb:false,
            },
            adgroupForm:{
                // 广告设置
                advertiser_id:'',
                // 营销内容
                marketing_goal:'',
                marketing_sub_goal:'',
                marketing_carrier_type:'',
                marketing_carrier_detail:{
                    'marketing_carrier_id':'',
                    'marketing_sub_carrier_id':'',
                    'marketing_carrier_name':'',
                },
                marketing_asset_id:'',
                marketing_asset_outer_spec:{
                    marketing_target_type:'',
                    marketing_asset_outer_id:'',
                },          
                optimization_goal:'',
                conversion_id:'',
                automatic_site_enabled:true,
                exploration_strategy:'AUTOMATIC_EXPLORATION',
                site_set:[],
                priority_site_set:[],
                scene_spec:{},
                // 定向
                targets:[
                    {   name:'1',
                        type_arr:{
                            geo_location_type:'NONE',
                            age_type:'NONE',
                            os_type:['NONE'],
                            wechat_type:['NONE'],
                            wechat_ad_type:['NONE'],
                            audience_type:['NONE'],
                        },
                        options:{
                            os_options:[
                                {label:'iOS系统',value:'IOS',children:[
                                    {label:'iOS 4.x',value:'IOS_VERSION_4'},
                                    {label:'iOS 5.x',value:'IOS_VERSION_5'},
                                    {label:'iOS 6.x',value:'IOS_VERSION_6'},
                                    {label:'iOS 7.x',value:'IOS_VERSION_7'},
                                    {label:'iOS 8.x',value:'IOS_VERSION_8'},
                                    {label:'iOS 9.x',value:'IOS_VERSION_9'},
                                    {label:'iOS 10.x',value:'IOS_VERSION_10'},
                                    {label:'iOS 11.x',value:'IOS_VERSION_11'},
                                    {label:'iOS 12.x',value:'IOS_VERSION_12'},
                                    {label:'iOS 13.x',value:'IOS_VERSION_13'},
                                    {label:'iOS 14.x',value:'IOS_VERSION_14'},
                                    {label:'iOS 15.x',value:'IOS_VERSION_15'},
                                    {label:'iOS 16.x',value:'IOS_VERSION_16'},
                                    {label:'iOS 17.x',value:'IOS_VERSION_17'},
                                ]},
                                {label:'Android系统',value:'ANDROID',children:[
                                    {label:'Android 1.x',value:'ANDROID_VERSION_1'},
                                    {label:'Android 2.x',value:'ANDROID_VERSION_2'},
                                    {label:'Android 3.x',value:'ANDROID_VERSION_3'},
                                    {label:'Android 4.x',value:'ANDROID_VERSION_4'},
                                    {label:'Android 5.x',value:'ANDROID_VERSION_5'},
                                    {label:'Android 6.x',value:'ANDROID_VERSION_6'},
                                    {label:'Android 7.x',value:'ANDROID_VERSION_7'},
                                    {label:'Android 8.x',value:'ANDROID_VERSION_8'},
                                    {label:'Android 9.x',value:'ANDROID_VERSION_9'},
                                    {label:'Android 10.x',value:'ANDROID_VERSION_10'},
                                    {label:'Android 11.x',value:'ANDROID_VERSION_11'},
                                    {label:'Android 12.x',value:'ANDROID_VERSION_12'},
                                    {label:'Android 13.x',value:'ANDROID_VERSION_13'},
                                    {label:'Android 14.x',value:'ANDROID_VERSION_14'},
                                ]},
                                {label:'Windows系统',value:'WINDOWS'},
                                {label:'塞班系统',value:'SYMBIAN'},
                                {label:'JAVA系统',value:'JAVA'},
                                {label:'Mac系统',value:'MAC'},
                                {label:'Harmony',value:'HARMONY'},
                            ],
                            exclude_os_options:[
                                {label:'iOS系统',value:'IOS',children:[
                                    {label:'iOS 4.x',value:'IOS_VERSION_4'},
                                    {label:'iOS 5.x',value:'IOS_VERSION_5'},
                                    {label:'iOS 6.x',value:'IOS_VERSION_6'},
                                    {label:'iOS 7.x',value:'IOS_VERSION_7'},
                                    {label:'iOS 8.x',value:'IOS_VERSION_8'},
                                    {label:'iOS 9.x',value:'IOS_VERSION_9'},
                                    {label:'iOS 10.x',value:'IOS_VERSION_10'},
                                    {label:'iOS 11.x',value:'IOS_VERSION_11'},
                                    {label:'iOS 12.x',value:'IOS_VERSION_12'},
                                    {label:'iOS 13.x',value:'IOS_VERSION_13'},
                                    {label:'iOS 14.x',value:'IOS_VERSION_14'},
                                    {label:'iOS 15.x',value:'IOS_VERSION_15'},
                                    {label:'iOS 16.x',value:'IOS_VERSION_16'},
                                    {label:'iOS 17.x',value:'IOS_VERSION_17'},
                                ]},
                                {label:'Android系统',value:'ANDROID',children:[
                                    {label:'Android 1.x',value:'ANDROID_VERSION_1'},
                                    {label:'Android 2.x',value:'ANDROID_VERSION_2'},
                                    {label:'Android 3.x',value:'ANDROID_VERSION_3'},
                                    {label:'Android 4.x',value:'ANDROID_VERSION_4'},
                                    {label:'Android 5.x',value:'ANDROID_VERSION_5'},
                                    {label:'Android 6.x',value:'ANDROID_VERSION_6'},
                                    {label:'Android 7.x',value:'ANDROID_VERSION_7'},
                                    {label:'Android 8.x',value:'ANDROID_VERSION_8'},
                                    {label:'Android 9.x',value:'ANDROID_VERSION_9'},
                                    {label:'Android 10.x',value:'ANDROID_VERSION_10'},
                                    {label:'Android 11.x',value:'ANDROID_VERSION_11'},
                                    {label:'Android 12.x',value:'ANDROID_VERSION_12'},
                                    {label:'Android 13.x',value:'ANDROID_VERSION_13'},
                                    {label:'Android 14.x',value:'ANDROID_VERSION_14'},
                                ]},
                                {label:'Windows系统',value:'WINDOWS'},
                                {label:'塞班系统',value:'SYMBIAN'},
                                {label:'JAVA系统',value:'JAVA'},
                                {label:'Mac系统',value:'MAC'},
                                {label:'Harmony',value:'HARMONY'},
                            ],
                            included_list_options:[],
                            excluded_list_options:[],
                            include_ad_options:[
                                {label:'关注过广告主微信公众号',value:'WECHAT_OFFICIAL_ACCOUNT_FOLLOWED'},
                                {label:'已安装你的应用',value:'APP_INSTALLED'},
                                {label:'领取过广告主微信卡券',value:'WECHAT_COUPON_OBTAINED'},
                                {label:'对微信公众号广告感兴趣',value:'WECHAT_OFFICIAL_ACCOUNT_AD_LIKE'},
                                {label:'对微信朋友圈广告感兴趣',value:'WECHAT_MOMENTS_AD_LIKE'},
                                {label:'曾经注册过你的小游戏',value:'MINI_GAME_WECHAT_REGISTERED'},
                            ],
                            excluded_ad_options:[
                                {label:'关注过广告主微信公众号',value:'WECHAT_OFFICIAL_ACCOUNT_FOLLOWED'},
                                {label:'已安装你的应用',value:'APP_INSTALLED'},
                                {label:'领取过广告主微信卡券',value:'WECHAT_COUPON_OBTAINED'},
                                {label:'对微信公众号广告感兴趣',value:'WECHAT_OFFICIAL_ACCOUNT_AD_LIKE'},
                                {label:'对微信朋友圈广告感兴趣',value:'WECHAT_MOMENTS_AD_LIKE'},
                                {label:'曾经注册过你的小游戏',value:'MINI_GAME_WECHAT_REGISTERED'},
                            ],
                            include_audience_options:[],
                            excluded_audience_options:[],
                        },
                        geo_location:{
                            location_types:[],
                            regions:[],
                            business_districts:[],
                            geo_location_auto_audience:true,
                        },
                        gender:['NONE'],
                        age:[
                            {
                                min:'14',
                                max:'66',
                            }
                        ],
                        education:['NONE'],
                        app_install_status:['NONE'],
                        marital_status:['NONE'],
                        network_type:['NONE'],
                        device_price:['NONE'],
                        game_consumption_level:['NONE'],
                        user_os:[],
                        excluded_os:[],
                        excluded_converted_audience:{
                            excluded_dimension:'',
                            conversion_behavior_list:[],
                            excluded_day:''
                        },
                        custom_audience:[],
                        excluded_custom_audience:[],
                        device_brand_model:{
                            included_list:[],
                            excluded_list:[],
                        },
                        wechat_ad_behavior:{
                            actions:[],
                            excluded_actions:[],
                        }
                    },
                ],

                adgroup_name:'',
                begin_date:'',
                end_date:'',
                first_day_begin_time:'',
                time_series:'',
                bid_amount:'',
                      
                
               
               
            },
            pickerOptions:{
              disabledDate(time) {
                const today = new Date();
                today.setHours(0);
                today.setMinutes(0);
                today.setSeconds(0);
                today.setMilliseconds(0);

                return time < today;
                },
            },
            rules:{
                adgroupForm:{
                    advertiser_id:[
                        { required: true, message: '请选择广告主', trigger: 'blur' }
                    ],
                    adgroup_name:[
                        { required: true, message: '请输入广告组名称', trigger: 'blur' }
                    ],
                    marketing_goal:[
                        { required: true, message: '请选择营销目的', trigger: 'change' }
                    ],
                    marketing_sub_goal:[
                        { required: true, message: '请选择二级营销目的', trigger: 'change' }
                    ],
                    marketing_carrier_type:[
                        { required: true, message: '请选择营销载体', trigger: 'change' }
                    ],
                    marketing_carrier_detail:{
                        marketing_carrier_id:[
                            { required: true, message: '请输入营销载体ID', trigger: 'blur' }
                        ]
                    },
                    marketing_asset_id:[
                        { validator: (rule, value, callback)=>{
                            if(!this.returnTypeStatus && !value){
                                callback(new Error('请选择产品ID'));
                            }
                            callback()
                        }, trigger: 'change' }
                    ],
                    marketing_asset_outer_spec:{
                        marketing_target_type:[
                            { required: true, message: '请选择产品类型', trigger: 'change' }
                        ],
                        marketing_asset_outer_id:[
                            { validator: (rule, value, callback)=>{
                                if(this.returnTypeStatus && !value){
                                    callback(new Error('请选择产品ID'))
                                }
                                callback()
                            }, trigger: 'change' }
                        ],
                    },
                    deep_conversion_spec:{
                        deep_conversion_behavior_spec:{
                            goal:[
                                { required: true, message: '请选择深度优化目标', trigger: 'change' }
                            ],
                            bid_amount:[
                                { required: true, message: '请输入深度优化行为的出价', trigger: 'blur' },
                                {validator: (rule, value, callback)=>{
                                    const regex = /^(?:\d+|\d{1,}\.\d{1,2})$/;
                                    if (!regex.test(value)) {
                                        callback(new Error('请输入正确的金额'));
                                    } else {
                                        callback();
                                    }
                                }, trigger: 'blur' }
                            ]
                        },
                        deep_conversion_behavior_advanced_spec:{
                            goal:[
                                { required: true, message: '请选择深度辅助目标', trigger: 'change' }
                            ],
                            bid_amount:[
                                { required: true, message: '请输入深度辅助优化行为的出价', trigger: 'blur' },
                                {validator: (rule, value, callback)=>{
                                    const regex = /^(?:\d+|\d{1,}\.\d{1,2})$/;
                                    if (!regex.test(value)) {
                                        callback(new Error('请输入正确的金额'));
                                    } else {
                                        callback();
                                    }
                                }, trigger: 'blur' }
                            ]
                        },
                        deep_conversion_worth_spec:{
                            goal:[
                                { required: true, message: '请选择深度优化ROI目标', trigger: 'change' }
                            ],
                            expected_roi:[
                                { required: true, message: '请输入深度优化ROI目标值', trigger: 'blur' },
                                {validator: (rule, value, callback)=>{
                                    const regex = /^(?:\d+|\d{1,}\.\d{1,3})$/;
                                    if (!regex.test(value)) {
                                        callback(new Error('请输入正确的金额,最多保留3位小数'));
                                    } 
                                    if(value>1000) {
                                        callback(new Error('取值范围:0~1000'));
                                    }
                                    callback();
                                }, trigger: 'blur' }
                            ]
                        },
                        deep_conversion_worth_advanced_spec:{
                            goal:[
                                { required: true, message: '请选择深度辅助ROI目标', trigger: 'change' }
                            ],
                            expected_roi:[
                                { required: true, message: '请输入深度辅助ROI目标值', trigger: 'blur' },
                                {validator: (rule, value, callback)=>{
                                    const regex = /^(?:\d+|\d{1,}\.\d{1,3})$/;
                                    if (!regex.test(value)) {
                                        callback(new Error('请输入正确的金额,最多保留3位小数'));
                                    }
                                    if(value>1000) {
                                        callback(new Error('取值范围:0~1000'));
                                    }
                                    callback();
                                }, trigger: 'blur' }
                            ]
                        },
                    },
                    end_date:[
                        { validator: (rule, value, callback)=>{
                            if(!this.adgroupForm.begin_date){
                                callback(new Error('请选择开始投放时间'));
                            }
                            if(!this.adgroupForm.end_date){
                                callback(new Error('请选择结束投放时间'));
                            }
                            callback()
                        }, trigger: 'change' }
                    ],
                    time_series:[
                        { required: true, message: '请选择投放时段', trigger: 'blur' }
                    ],
                    bid_amount:[
                        { required: true, message: '请输入广告出价', trigger: 'blur' },
                        {validator: (rule, value, callback)=>{
                            const regex = /^(?:\d+|\d{1,}\.\d{1,3})$/;
                            if (!regex.test(value)) {
                                callback(new Error('请输入正确的金额'));
                            } else {
                                callback();
                            }
                        }, trigger: 'blur' }
                    ]
                },
            },
            options:{
                accounts:[],
                marketing_goal_options:[],
                marketing_sub_goal_options:[],
                marketing_carrier_type_options:[],
                marketing_target_type_options:[],
                optimization_goal_options:[],
                deep_conversion_worth_spec_options:[],
                deep_conversion_behavior_spec_options:[],
                deep_conversion_worth_advanced_spec_options:[],
                deep_conversion_behavior_advanced_spec_options:[],
                forward_link_assist_options:[],
                marketing_target_assets_options:{
                    data:[],
                    page:1,
                    pagesize:30,
                    total:0
                },
                conversion_id_options:{
                    data:[],
                    page:1,
                    pagesize:30,
                    total:0
                },
                targeting_options:{
                    data:[],
                    page:1,
                    pagesize:30,
                    total:0
                },
                wechat_position_options:[],
                wechat_channels_scene_options:[],
                display_scene_options:[
                    {label:'Banner',value:'DISPLAY_SCENE_BANNER'},
                    {label:'插屏',value:'DISPLAY_SCENE_INLINE'},
                    {label:'开屏',value:'DISPLAY_SCENE_SPLASH'},
                    {label:'原生',value:'DISPLAY_SCENE_NATIVE'},
                    {label:'激励视频',value:'DISPLAY_SCENE_REWARDED_VIDEO'},
                ],
                official_account_media_category_options:[],
                mini_program_and_mini_game_options:[],
                pay_scene_options:[],

                mobile_union_category_options:[],
                
                union_position_package_options:[],
                exclude_union_position_package_options:[],
                priority_site_set_options:[],
                
                regions_options:[],
                districts_options:[],
                
            }
        }
    },
    computed:{
        getOptimizationGoalValues() {
            var arr = [
                'MARKETING_CARRIER_TYPE_APP_ANDROID',
                'MARKETING_CARRIER_TYPE_APP_IOS',
                'MARKETING_CARRIER_TYPE_WECHAT_MINI_GAME' 
            ]
            if(arr.indexOf(this.adgroupForm.marketing_carrier_type) !== -1){
                return this.adgroupForm.marketing_goal && this.adgroupForm.marketing_sub_goal && this.adgroupForm.marketing_carrier_type && this.adgroupForm.marketing_asset_outer_spec.marketing_target_type && this.adgroupForm.marketing_carrier_detail.marketing_carrier_id
            }else{
                return this.adgroupForm.marketing_goal && this.adgroupForm.marketing_sub_goal && this.adgroupForm.marketing_carrier_type && this.adgroupForm.marketing_asset_outer_spec.marketing_target_type
            }
        },
        returnTypeStatus(){
            var arr = [
                "MARKETING_TARGET_TYPE_APP_ANDROID",
                "MARKETING_TARGET_TYPE_APP_IOS",
                "MARKETING_TARGET_TYPE_APP_QUICK_APP",
                "MARKETING_TARGET_TYPE_WECHAT_MINI_GAME",
                "MARKETING_TARGET_TYPE_WECHAT_CHANNELS",
                "MARKETING_TARGET_TYPE_MINI_PROGRAM_WECHAT",
                "MARKETING_TARGET_TYPE_WECHAT_CHANNELS_LIVE",
                "MARKETING_TARGET_TYPE_WECHAT_CHANNELS_LIVE_RESERVATION",
                "MARKETING_TARGET_TYPE_CONSUMER_PRODUCT",
                "MARKETING_TARGET_TYPE_WECHAT_OFFICIAL_ACCOUNT",
                "MARKETING_TARGET_TYPE_LOCAL_STORE",
                "MARKETING_TARGET_TYPE_LOCAL_STORE_PACKAGE",
                "MARKETING_TARGET_TYPE_COMMODITY_SET",
                "MARKETING_TARGET_TYPE_WECHAT_WORK",
                "MARKETING_TARGET_TYPE_MINI_GAME_QQ",
                "MARKETING_TARGET_TYPE_PC_GAME"
            ]
            if(arr.indexOf(this.adgroupForm.marketing_asset_outer_spec.marketing_target_type) !== -1){
                return true
            }else{
                return false
            }
        }
    },
    watch:{
        getOptimizationGoalValues:{
            handler(newValue, oldValue) {
                this.get_optimization_goal_data();
            }
        }
    },
    methods: {
        
        exChange(values,iindex,field){
            this.adgroupForm.targets[iindex].options[field].forEach((item,index)=>{
                if(values.indexOf(item.value) != -1){
                    this.$set(this.adgroupForm.targets[iindex].options[field][index],'disabled',true)
                }else{
                    this.$set(this.adgroupForm.targets[iindex].options[field][index],'disabled',false)
                }
            })
        },
        osChange(values,iindex,field){
            this.adgroupForm.targets[iindex].options[field].forEach((item,index)=>{
                if(values.indexOf(item.value) != -1){
                    this.$set(this.adgroupForm.targets[iindex].options[field][index],'disabled',true)
                }else{
                    this.$set(this.adgroupForm.targets[iindex].options[field][index],'disabled',false)
                }
                if(item.children && item.children.length > 0){
                    var num = 0
                    item.children.forEach((child,cindex)=>{
                        if(values.indexOf(child.value) != -1){
                            this.$set( this.adgroupForm.targets[iindex].options[field][index]['children'][cindex],'disabled',true)
                            num = num+1
                        }else{
                            this.$set( this.adgroupForm.targets[iindex].options[field][index]['children'][cindex],'disabled',false)

                        }
                    })
                    if(num == item.children.length){
                        this.$set( this.adgroupForm.targets[iindex].options[field][index],'disabled',true)
                    }else{
                        this.$set( this.adgroupForm.targets[iindex].options[field][index],'disabled',false)
                    }
                }
            })
        },
        typeAction(value,index,fieldArr,num){
            if (value.length == 0 || value[value.length - 1] == 'NONE') {
                // 如果选择了“不限”，则清空其他选项
                if(fieldArr.length == 1){
                    this.adgroupForm.targets[index]['type_arr'][fieldArr[0]] = ['NONE'];
                }else{
                    this.adgroupForm.targets[index]['type_arr'][fieldArr[0]][fieldArr[1]] = ['NONE'];
                }
            } else {
                if (num == 1) {
                    // 如果选择了多个选项，保留最后一个选中的选项
                    if(fieldArr.length == 1){
                        this.adgroupForm.targets[index]['type_arr'][fieldArr[0]] = [value[value.length - 1]];
                    }else{
                        this.adgroupForm.targets[index]['type_arr'][fieldArr[0]][fieldArr[1]] = [value[value.length - 1]];
                    }
                }else{
                    // 如果没有选择“不限”，则允许选择其他选项
                    if(fieldArr.length == 1){
                        this.adgroupForm.targets[index]['type_arr'][fieldArr[0]] = value.filter(item => item !== 'NONE');
                    }else{
                        this.adgroupForm.targets[index]['type_arr'][fieldArr[0]][fieldArr[1]] = value.filter(item => item !== 'NONE');
                    }
                }
            }
            if(fieldArr.indexOf('wechat_type')!=-1){
                this.$api.get('pyadver/gettargetingtags',{
                    account_id: this.adgroupForm.advertiser_id,
                    type:'DEVICE_BRAND_MODEL',
                }).then(res => {
                    this.adgroupForm.targets[index].options.included_list_options = res.data
                    this.adgroupForm.targets[index].options.excluded_list_options = res.data
                })
            }
            if (fieldArr.indexOf('audience_type')!=-1){
                this.$api.get('pyadver/getcustomaudiences',{
                    account_id: this.adgroupForm.advertiser_id,
                }).then(res => {
                    this.adgroupForm.targets[index].options.include_audience_options = res.data
                    this.adgroupForm.targets[index].options.excluded_audience_options = res.data
                })
            }
        },
        noneAction(value,index,fieldArr,num){
            if (value.length == 0 || value[value.length - 1] == 'NONE') {
                // 如果选择了“不限”，则清空其他选项
                if(fieldArr.length == 1){
                    this.adgroupForm.targets[index][fieldArr[0]] = ['NONE'];
                }else{
                    this.adgroupForm.targets[index][fieldArr[0]][fieldArr[1]] = ['NONE'];
                }
            } else {
                if (num == 1) {
                    // 如果选择了多个选项，保留最后一个选中的选项
                    if(fieldArr.length == 1){
                        this.adgroupForm.targets[index][fieldArr[0]] = [value[value.length - 1]];
                    }else{
                        this.adgroupForm.targets[index][fieldArr[0]][fieldArr[1]] = [value[value.length - 1]];
                    }
                }else{
                    // 如果没有选择“不限”，则允许选择其他选项
                    if(fieldArr.length == 1){
                        this.adgroupForm.targets[index][fieldArr[0]] = value.filter(item => item !== 'NONE');
                    }else{
                        this.adgroupForm.targets[index][fieldArr[0]][fieldArr[1]] = value.filter(item => item !== 'NONE');
                    }
                }
            }
        },
        getTargetTagList(val){
            if(val != 'NONE'){
                this.$api.get('pyadver/gettargetingtags',{
                    account_id: this.adgroupForm.advertiser_id,
                    type:val,
                }).then(res => {
                    if(val=='REGION'){
                        this.options.regions_options = res.data
                    }else if(val=='BUSINESS_DISTRICT'){
                        this.options.districts_options = res.data
                    }
                    
                })
            }else{
                if(val=='REGION'){
                    this.options.regions_options = []
                }else if(val=='BUSINESS_DISTRICT'){
                    this.options.districts_options = []
                }
            }
        },
        changeSetSite(vals){
            
            if(vals.indexOf('SITE_SET_MOBILE_YYB') != -1 && vals.length > 1){
                console.log(vals.indexOf('SITE_SET_MOBILE_YYB') != -1)
                console.log(vals.length > 1)
                this.$refs.setCascader.clearCheckedNodes()
                this.adgroupForm.site_set = []
            }
            
        },
        getSetList(val){
            if(val == 'STEADY_EXPLORATION' || val == false){
                this.$api.get('pyadver/getsitelist',{
                account_id: this.adgroupForm.advertiser_id,
                marketing_goal:this.adgroupForm.marketing_goal,
                marketing_sub_goal:this.adgroupForm.marketing_sub_goal,
                marketing_carrier_type:this.adgroupForm.marketing_carrier_type,
                marketing_target_type:this.adgroupForm.marketing_asset_outer_spec.marketing_target_type
                },
                res => {
                    this.options.priority_site_set_options = res.data
                    if(val == false){
                        this.options.priority_site_set_options.push({label:'应用宝',value:'SITE_SET_MOBILE_YYB'})
                    }
                })
            }
        },
        closeDialogToView(){
            var text = []
            if(this.isOpen.wx_xcx_dt){
                var labels = this.options.wechat_position_options.filter(item => this.adgroupForm.scene_spec.wechat_position.indexOf(item.value) != -1).map(item => item.label)
                text.push({title:'微信公众号与小程序定投',content:labels})
            }
            if(this.isOpen.wx_sph_dt){
                var labels = this.options.wechat_channels_scene_options.filter(item => this.adgroupForm.scene_spec.wechat_channels_scene.indexOf(item.value) != -1).map(item => item.label)
                text.push({title:'微信视频号定投',content:labels})
            }
            if(this.isOpen.wx_xcx_cj){
                var labels = this.options.official_account_media_category_options.filter(item => this.adgroupForm.scene_spec.wechat_scene.official_account_media_category.indexOf(item.value) != -1).map(item => item.label)
                text.push({title:'公众号媒体类型',content:labels})
                var labels = this.options.mini_program_and_mini_game_options.filter(item => this.adgroupForm.scene_spec.wechat_scene.mini_program_and_mini_game.indexOf(item.value) != -1).map(item => item.label)
                text.push({title:'小程序小游戏流量类型',content:labels})
                var labels = this.options.pay_scene_options.filter(item => this.adgroupForm.scene_spec.wechat_scene.pay_scene.indexOf(item.value) != -1).map(item => item.label)
                text.push({title:'订单详情页消费场景',content:labels})
            }
            if(this.isOpen.ylh_gg_cj){
                var labels = this.options.display_scene_options.filter(item => this.adgroupForm.scene_spec.display_scene.indexOf(item.value) != -1).map(item => item.label)
                text.push({title:'优量汇广告展示场景',content:labels})
            }
            if(this.isOpen.ylh_mt_lx){
                var data = JSON.parse(JSON.stringify(this.options.mobile_union_category_options))
                var news_datas = this.flattenOptions(data)
                var labels = news_datas.filter(item => this.adgroupForm.scene_spec.mobile_union_category.indexOf(item.value) != -1).map(item => item.label)
                text.push({title:'优量汇媒体类型',content:labels})
            }
            if(this.isOpen.ylh_zdy_dt){
                var labels = this.options.union_position_package_options.filter(item => this.adgroupForm.scene_spec.union_position_package.indexOf(item.value) != -1).map(item => item.label)
                text.push({title:'优量汇自定义定投',content:labels})
            }
            if(this.isOpen.ylh_zdy_pb){
                var labels = this.options.exclude_union_position_package_options.filter(item => this.adgroupForm.scene_spec.exclude_union_position_package.indexOf(item.value) != -1).map(item => item.label)
                text.push({title:'优量汇自定义屏蔽',content:labels})
            }
            this.scene_info = text
            this.dialogSceneVisible = false
        },
        flattenOptions(options) {
            return options.reduce((acc, option) => {
                acc.push(option);
                if (option.children && option.children.length > 0) {
                    acc.push(...this.flattenOptions(option.children));
                }
                return acc;
            }, []);
        },
        changeScene(val,type){
            if(type == 'WECHAT_POSITION'){
                if(val){
                    this.$set(this.adgroupForm.scene_spec, 'wechat_position', [])
                    this.get_scene_data(type,(res)=>{
                        this.options.wechat_position_options = res
                    })
                }else{
                    this.$delete(this.adgroupForm.scene_spec,'wechat_position')
                    this.options.wechat_position_options = []
                }
            }else if(type == 'WECHAT_CHANNELS_SCENE'){
                if(val){
                    this.$set(this.adgroupForm.scene_spec, 'wechat_channels_scene', [])
                    this.get_scene_data(type,(res)=>{
                        this.options.wechat_channels_scene_options = res
                    })
                }else{
                    this.$delete(this.adgroupForm.scene_spec,'wechat_channels_scene')
                    this.options.wechat_channels_scene_options = []
                }
            }else if(type == 'OFFICIAL_ACCOUNT_MEDIA_CATEGORY-MINI_PROGRAM_AND_MINI_GAME-PAY_SCENE'){
                var arr_type = type.split('-')
                arr_type.forEach(element => {
                    if(val){
                        this.$set(this.adgroupForm.scene_spec, 'wechat_scene', {
                            'official_account_media_category':[],
                            'mini_program_and_mini_game':[],
                            'pay_scene':[],
                        })
                        this.get_scene_data(element,(res)=>{
                            if(element == 'OFFICIAL_ACCOUNT_MEDIA_CATEGORY'){
                                this.options.official_account_media_category_options = res
                            }else if(element == 'MINI_PROGRAM_AND_MINI_GAME'){
                                this.options.mini_program_and_mini_game_options = res
                            }else if(element == 'PAY_SCENE'){
                                this.options.pay_scene_options = res
                            }
                        })
                    }else{
                        this.$delete(this.adgroupForm.scene_spec,'wechat_scene')
                        this.options.official_account_media_category_options = []
                        this.options.mini_program_and_mini_game_options = []
                        this.options.pay_scene_options = []
                    }
                });
            }else if(type == 'zz'){
                 if(val){
                    this.$set(this.adgroupForm.scene_spec, 'display_scene', [])
                }else{
                    this.$delete(this.adgroupForm.scene_spec,'display_scene')
                }
            }else if(type == 'MOBILE_UNION_CATEGORY'){
                if(val){
                    this.$set(this.adgroupForm.scene_spec, 'mobile_union_category', [])
                    this.get_scene_data(type,(res)=>{
                        this.options.mobile_union_category_options = res
                    })
                }else{
                    this.$delete(this.adgroupForm.scene_spec,'mobile_union_category')
                    this.options.mobile_union_category_options = []
                }
            }else if(type == 'UNION_PACKAGE_TYPE_INCLUDE'){
                if(val){
                    this.$set(this.adgroupForm.scene_spec, 'union_position_package', [])
                    this.get_packages_data(type,(res)=>{
                        this.options.union_position_package_options = res
                    })
                }else{
                    this.$delete(this.adgroupForm.scene_spec,'union_position_package')
                    this.options.union_position_package_options = []
                }
            }else if(type == 'UNION_PACKAGE_TYPE_EXCLUDE'){
                if(val){
                    this.$set(this.adgroupForm.scene_spec, 'exclude_union_position_package', [])
                    this.get_packages_data(type,(res)=>{
                        this.options.exclude_union_position_package_options = res
                    })
                }else{
                    this.$delete(this.adgroupForm.scene_spec,'exclude_union_position_package')
                    this.options.exclude_union_position_package_options = []
                }
            }
        },
        get_packages_data(type, callback){
            this.$api.get('pyadver/getunionpositionpackages',{
                account_id: this.adgroupForm.advertiser_id,
                union_package_type: type},
            res => {
                if(res.code == 0){
                    if (callback) {
                        callback(res.data)
                    }
                }
            })
        },
        get_scene_data(type, callback){
            this.$api.get('pyadver/getscenespectags',{
                account_id: this.adgroupForm.advertiser_id,
                type: type},
            res => {
                if(res.code == 0){
                    if (callback) {
                        callback(res.data)
                    }
                }
            })
        },
        openSceneDialog(){
            this.dialogSceneVisible = true
        },
        openTargetDialog(){
            this.getTargetingList(1)
            this.dialogTargetVisible = true
        },
        getTargetingList(page){
            this.$api.get('pyadver/gettargetings',{
                account_id: this.adgroupForm.advertiser_id,
                name:this.targetForm.name,
                page:page, 
                pagesize:this.options.targeting_options.pagesize
                
            }).then(res => {
                if(res.code == 0){
                    this.options.targeting_options = res.data
                }
            })
        },
        addAgeInfo(index){
            if(this.adgroupForm.targets[index].age.length >= 5){
                this.$message.error('最多可以添加5次')
                return
            }
            this.adgroupForm.targets[index].age.push(
                {
                    min: '14',
                    max: '66'
                }
            )
        },
        delAgeInfo(index){
            this.adgroupForm.targets[index].age.splice(index, 1)
        },
        handleTabsEdit(){
            console.log(123)
        },
        openConversion(){
            this.dialogConversionVisible = true
            this.get_conversion_id_options(1)
        },
        get_conversion_id_options(page){
            this.$api.get('pyadver/getconversions',{
                account_id: this.adgroupForm.advertiser_id,
                id:this.conversionForm.id,
                page:page, 
                pagesize:this.options.conversion_id_options.pagesize},
            res => {
                if(res.code == 0){
                    this.options.conversion_id_options = res.data
                }
            })
        },
        // 获取优化目的chilren数据
        changeOptimizationGoal(val){
            var foundItem = this.options.optimization_goal_options.find(item => item.value === val);
            var types = [
                'DEEP_CONVERSION_WORTH',
                'DEEP_CONVERSION_BEHAVIOR',
                'DEEP_CONVERSION_WORTH_ADVANCED',
                'DEEP_CONVERSION_BEHAVIOR_ADVANCED',
            ];
            var info_data = foundItem.children.find(item => types.indexOf(item.type) !== -1 && item.data.length > 0)
            if (info_data){
                this.$set(this.adgroupForm, 'deep_conversion_spec', {})
                this.$set(this.adgroupForm.deep_conversion_spec, 'deep_conversion_type', info_data['type'])
                if(info_data.type === 'DEEP_CONVERSION_WORTH'){
                    this.$set(this.adgroupForm.deep_conversion_spec, 'deep_conversion_worth_spec', {
                            'goal':'',
                            'expected_roi':''
                    })
                    this.options.deep_conversion_worth_spec_options = info_data.data
                }else if(info_data.type === 'DEEP_CONVERSION_BEHAVIOR'){
                    this.$set(this.adgroupForm.deep_conversion_spec, 'deep_conversion_behavior_spec', {
                            'goal':'',
                            'expected_roi':''
                    })
                    this.options.deep_conversion_behavior_spec_options = info_data.data

                }else if(info_data.type === 'DEEP_CONVERSION_WORTH_ADVANCED'){
                    this.$set(this.adgroupForm.deep_conversion_spec, 'deep_conversion_worth_advanced_spec', {
                            'goal':'',
                            'expected_roi':''
                    })
                    this.options.deep_conversion_worth_advanced_spec_options = info_data.data
                }else if(info_data.type === 'DEEP_CONVERSION_BEHAVIOR_ADVANCED'){
                    this.$set(this.adgroupForm.deep_conversion_spec, 'deep_conversion_behavior_advanced_spec', {
                            'goal':'',
                            'expected_roi':''
                    })
                    this.options.deep_conversion_behavior_advanced_spec_options = info_data.data
                }
                var z_data = foundItem.children.find(item => item.type == 'ZHUGONG')
                if(z_data){
                    this.$set(this.adgroupForm, 'forward_link_assist', '')
                    this.options.forward_link_assist_options = z_data.data
                }
                // console.log(this.adgroupForm)
            }else{
                delete this.adgroupForm.deep_conversion_spec
            }
        },
        // 获取优化目标数据
        get_optimization_goal_data(){
            var query = {
                account_id:this.adgroupForm.advertiser_id,
                marketing_goal:this.adgroupForm.marketing_goal,
                marketing_sub_goal:this.adgroupForm.marketing_sub_goal,
                marketing_carrier_type:this.adgroupForm.marketing_carrier_type,
                marketing_target_type:this.adgroupForm.marketing_asset_outer_spec.marketing_target_type
            }
            var arr = [
                'MARKETING_CARRIER_TYPE_APP_ANDROID',
                'MARKETING_CARRIER_TYPE_APP_IOS',
                'MARKETING_CARRIER_TYPE_WECHAT_MINI_GAME' 
            ]
            if(arr.indexOf(this.adgroupForm.marketing_carrier_type) !== -1){
                query['marketing_carrier_id'] = this.adgroupForm.marketing_carrier_detail.marketing_carrier_id
            }
            this.$api.get('pyadver/getoptimization', query, res => {
                if (res.code == 0) {
                    this.options.optimization_goal_options = res.data

                }
            })
        },
        // 选中数据行
        handleRowClick(row) {
            this.selectedRow = row;
        },
        handleRowClickConversion(row){
            this.selectedRowConver = row;
        },
        handleRowClickTarget(rows){
            this.selectedRowTarget = rows;
        },
        actionTargetId(){
            if(this.selectedRowTarget.length <= 0){
                this.$message.error('未选择数据行')
                return
            }
            var arrs = []
            this.selectedRowTarget.forEach(item => {
                arrs.push(item.targeting)
            })
            this.adgroupForm.targets = arrs
            this.dialogTargetVisible = false
        },
        actionConverId(){
            if(!this.selectedRowConver || !this.selectedRowConver.conversion_id){
                this.$message.error('未选择数据行')
                return
            }
            this.adgroupForm.conversion_id = this.selectedRowConver.conversion_id
            this.dialogTableVisible = false
        },
        actionId(){
            if(!this.selectedRow || !this.selectedRow.value){
                this.$message.error('未选择数据行')
                return
            }
            if(this.returnTypeStatus){
                this.adgroupForm.marketing_asset_outer_spec.marketing_asset_outer_id = this.selectedRow.value
            }else{
                this.adgroupForm.marketing_asset_id = this.selectedRow.value
            }
            this.dialogTableVisible = false
        },
        onSubmitConversion(){
            this.get_conversion_id_options(1)
        },
        onSubmitTarget(){
            this.getTargetingList(1)
        },
        onSubmit(){
            this.get_marketing_target_assets(1)
        },
        openProductDialog(){
            this.dialogTableVisible = true
            this.get_marketing_target_assets(1)
        },
        // 获取产品列表
        get_marketing_target_assets(page){
            this.$api.get('pyadver/gettargetassets',{
                account_id:this.adgroupForm.advertiser_id,
                marketing_target_type:this.adgroupForm.marketing_asset_outer_spec.marketing_target_type,
                name:this.productForm.name, id:this.productForm.id, 
                page:page, 
                pagesize:this.options.marketing_target_assets_options.pagesize
            },res=>{
                if (res.code == 0) {
                    this.options.marketing_target_assets_options = res.data
                }
            })
        },
        // 营销目的change事件
        change_advertiser(val){
            // 获取营销表达组合
            this.get_marketing_rules_info(val)
        },
        get_marketing_rules_info(account_id){
            this.$api.get('pyadver/getrules',{account_id: account_id},
            res => {
                if(res.code == 0){
                    this.options.marketing_goal_options = res.data
                    this.$set(this.adgroupForm, 'marketing_goal', res.data[0]['value'])
                    this.change_marketing_sub_goal_options(res.data[0]['value'])
                }
            })
        },
        change_marketing_sub_goal_options(val){
            
            var data_options = this.options.marketing_goal_options.find(item => item.value == val)
            if(data_options.children.length > 0){
                this.options.marketing_sub_goal_options = data_options.children
            }else{
                this.options.marketing_sub_goal_options = []
            }
            this.adgroupForm.marketing_sub_goal = ''
            this.adgroupForm.marketing_asset_outer_spec.marketing_target_type = ''
            this.options.marketing_target_type_options = []
            this.adgroupForm.marketing_carrier_type = ''
            this.options.marketing_carrier_type_options = []
        },
        change_marketing_target_type_options(val){
            var d_options = this.options.marketing_goal_options.find(item => item.value == this.adgroupForm.marketing_goal)
            var data_options = d_options.children.find(item => item.value == val)
            if(data_options.children.length > 0){
                this.options.marketing_target_type_options = data_options.children
            }else{
                this.options.marketing_target_type_options = []
            }
            this.adgroupForm.marketing_asset_outer_spec.marketing_target_type = ''
            this.adgroupForm.marketing_carrier_type = ''
            this.options.marketing_carrier_type_options = []        
        },
        change_marketing_carrier_type_options(val){
            var d_options = this.options.marketing_goal_options.find(item => item.value == this.adgroupForm.marketing_goal)
            var da_options = d_options.children.find(item => item.value == this.adgroupForm.marketing_sub_goal)
            var data_options = da_options.children.find(item => item.value == val)
            if(data_options.children.length > 0){
                this.options.marketing_carrier_type_options = data_options.children
            }else{
                this.options.marketing_carrier_type_options = []
            }
            this.adgroupForm.marketing_carrier_type = ''                    
        },
        remoteAccount(query){
            var params = {}
            if (query) {
                params['query'] = query
            }
            this.$api.get('release/getUserAccountIdList',params,res=>{
                if (res.code == 0) {
                    this.options.accounts = res.data
                }
            })
        },
        // 打开广告组抽屉        
        createTemplate() {
            this.remoteAccount()
            this.drawer = true;
        },
        changeMedia: function() {
            this.$emit('update:media', '')
            this.$emit('update:dialogMediaVisible', true)
        },
    }
}
</script>
<style scoped>
.k-page-content /deep/ .target-dialog {
  height: calc(100% - 80px);
}

.k-page-content /deep/ .target-dialog .el-dialog__body {
  height: calc(100% - 110px);
}
.k-page-content /deep/ .target-dialog .el-tabs {
  height: 100%;
}

.k-page-content /deep/ .target-dialog .el-tabs .el-tabs__content {
  height: calc(100% - 55px);
}

.k-page-content /deep/ .target-dialog .el-tabs .el-tabs__content .el-tab-pane {
  height: 100%;
}

.k-page-content
  /deep/
  .target-dialog
  .el-tabs
  .el-tabs__content
  .el-tab-pane
  .target-box {
  height: 100%;
}

.k-page-content /deep/ .target-dialog .el-dialog__body {
  padding: 0 16px;
}
.box-eltab {
  width: 100%;
}
.top-filter {
  background-color: #fff;
  padding: 16px 16px 0;
}
.ks_toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.ks_toolbar .title {
  font-size: 16px;
  font-weight: bold;
  display: flex;
}

.ks_toolbar .title span {
  font-size: 14px;
  color: #999;
  font-weight: normal;
  margin-left: 10px;
}
.date-pickers {
  display: flex;
  align-items: center;
}
.date-pickers .el-date-editor {
  margin-right: 10px; /* 可以根据需要调整间距 */
}
.box-card {
  margin-bottom: 30px;
}
</style>
